module.exports = __webpack_public_path__ + "static/media/i_contact.a22877c0.svg";